import React from "react";
import AddIcon from "@mui/icons-material/Add";
import RightSideModel from "src/components/popup/rightSide/RightSideModel";
import { allowedToCreateEntity } from "src/constants/role";
import useAuth from "src/hooks/useAuth";
import { useGetPermissionAccessControl } from "src/context/PermissionAccessControl";
import Controls from "src/components/form/controls/Controls";
import { isOpenPopup } from "src/utils/isOpenPopup";
import FLFPairingTypeForm from "../form/FLFPairingTypeForm/FLFPairingTypeForm";

const titlePopup = (isEdit) => {
  return isEdit ? "Edit Pairing Type" : "Create Pairing Type";
};

const FLFPairingTypePopup = ({
  recordForEdit,
  openPopup,
  setOpenPopup,
  handleOpenPopup,
  addOrEdit,
  errorsForm,
}) => {
  const { auth } = useAuth();
  const permissionsAccessControl = useGetPermissionAccessControl();
  return (
    <>
      {allowedToCreateEntity(auth?.permissions, permissionsAccessControl) && (
        <Controls.Button
          text="Add New"
          variant="outlined"
          startIcon={<AddIcon />}
          onClick={() => handleOpenPopup(isOpenPopup, null)}
        />
      )}
      <RightSideModel
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        title={titlePopup(Boolean(recordForEdit))}
      >
        <FLFPairingTypeForm
          recordForEdit={recordForEdit}
          addOrEdit={addOrEdit}
          errorsForm={errorsForm}
        />
      </RightSideModel>
    </>
  );
};

export default FLFPairingTypePopup;
